import { Layer } from "@fluentui/react";
import { makeStyles } from "@fluentui/react-components";
import { useEffect, useRef } from "react";
import { SkanskaColorTokens } from "../../style/colors";
import VsaaLogo from "../../assets/icons/Skanska_VSAA_logotype_free_RGB.png";
import { UserSettingsMenu } from "./UserSettingsMenu";
import { AdminBreadcrumb } from "../AdminBreadcrumb";
import { useGetUserAccessLevel } from "../../hooks/useGetUserAccessLevel";

const headerHeightCssVariable = "--vsaa-header-height";

const useClasses = makeStyles({
  homeLink: {
    textDecoration: "none",
    color: SkanskaColorTokens.color_secondary_black,
    fontSize: "24px",
  },
  headerContent: {
    maxWidth: "1900px",
    margin: "auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    height: "40px",
    backgroundColor: "#FFF",
  },
  personIconContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
  },
  breadcrumbContainer: {
    maxWidth: "1900px",
    margin: "auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  logo: {
    height: "35px",
  },
});

function Header() {
  const classes = useClasses();
  const accessLevel = useGetUserAccessLevel();
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = headerRef.current;

    if (!element) {
      return;
    }

    const updateHeight = () => {
      document.documentElement.style.setProperty(
        headerHeightCssVariable,
        `${element.offsetHeight}px`
      );
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
      document.documentElement.style.setProperty(
        headerHeightCssVariable,
        "0px"
      );
    };
  }, [accessLevel]);

  return (
    <>
      <Layer>
        <div ref={headerRef}>
          <div className={classes.headerContent}>
            <a
              className={classes.homeLink}
              href={import.meta.env.VITE_CLIENT_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={VsaaLogo} alt="Vsaa" className={classes.logo} />
            </a>
            <div className={classes.personIconContainer}>
              <div>
                <UserSettingsMenu />
              </div>
            </div>
          </div>
        </div>
      </Layer>
      {accessLevel > 1 && (
        <div className={classes.breadcrumbContainer}>
          <AdminBreadcrumb />
        </div>
      )}
    </>
  );
}

export default Header;
